import { useState } from 'react';
import {
    VStack,
    Box,
    Button,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import PartnerStatus from './formFields/PartnerStatus';
import ActiveStatus from './formFields/ActiveStatus';
import DeletePartnerModal from '../components/DeletePartnerModal';
import { usePartnerForm } from '../hooks/usePartnerForm';
import { PARTNER_MODES } from '../constants';

// eslint-disable-next-line no-unused-vars
const PartnerAdmin = ({ darkMode, errors, touched, resetToMainTable }) => {
    const { mode } = usePartnerForm();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [hasChange, setHasChange] = useState(false);

    const isEditMode = mode === PARTNER_MODES.EDIT;

    return (
        <VStack spacing={4} align="stretch">
            {/* <Box p={4} borderWidth="1px" borderRadius="md">
                <VStack spacing={4} align="stretch">
                    <PartnerStatus
                        darkMode={darkMode}
                        errors={errors}
                        touched={touched}
                    />
                    <ActiveStatus
                        darkMode={darkMode}
                        hasChange={hasChange}
                        setHasChange={setHasChange}
                    />
                </VStack>
            </Box> */}

            {isEditMode && (
                <Box 
                    p={6} 
                    borderWidth="1px" 
                    borderRadius="md" 
                    borderColor={darkMode ? 'red.600' : 'red.300'}
                    bg={darkMode ? 'black' : 'white'}>
                    <VStack spacing={4} align="stretch">
                        {/* <Text fontSize="lg" fontWeight="600" color="red.700">
                            Danger Zone
                        </Text> */}
                        <Box>
                            <Text fontSize="md" fontWeight="500" mb={2} color={darkMode ? 'white' : 'gray.800'}>
                                Delete
                            </Text>
                            <Text fontSize="sm" color={darkMode ? 'gray.300' : 'gray.700'} mb={3}>
                                By deleting a Partner, invoices will change to finalizing and no further billing will occur
                            </Text>
                            <Button
                                colorScheme="red"
                                onClick={onOpen}
                                size="md">
                                Delete
                            </Button>
                        </Box>
                    </VStack>
                </Box>
            )}

            <DeletePartnerModal
                isOpen={isOpen}
                onClose={onClose}
                resetToMainTable={resetToMainTable}
            />
        </VStack>
    );
};

export default PartnerAdmin;
